import { render, staticRenderFns } from "./CreateLineOfSupervisionPage.vue?vue&type=template&id=54be6263&scoped=true"
import script from "./CreateLineOfSupervisionPage.vue?vue&type=script&lang=js"
export * from "./CreateLineOfSupervisionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54be6263",
  null
  
)

export default component.exports